import { useState, useEffect, useRef } from "react";
import SliderNavigation from "./common/SliderNavigation";
import { FaPlay, FaPause } from "react-icons/fa";
import "../styles/VideoPhotos.scss";
import Title from "./common/Title";

const VideoPhotos = ({ gallery = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [vids, setVids] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  // collect only items that actually have a video URL
  // useEffect(() => {
  //   const tVids = (gallery || []).filter(
  //     (item) => item?.video && String(item.video).trim() !== ""
  //   );
  //   setVids(tVids);
  //   setCurrentSlide(0);
  //   setIsPlaying(false);
  //   if (videoRef.current) {
  //     videoRef.current.pause();
  //     videoRef.current.currentTime = 0;
  //   }
  // }, [gallery]);

  useEffect(() => {
    // prevent looping when gallery hasn't actually changed
    if (JSON.stringify(gallery) === JSON.stringify(vids)) return;

    const tVids = (gallery || []).filter(
      (item) => item?.video && String(item.video).trim() !== ""
    );

    setVids(tVids);
    setCurrentSlide(0);
    setIsPlaying(false);

    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [gallery]);

  // when slide changes, stop current video and reset state
  useEffect(() => {
    if (!vids.length) return;
    setIsPlaying(false);
    if (videoRef.current) {
      videoRef.current.pause();
      // force reload the new source
      videoRef.current.load();
    }
  }, [currentSlide, vids.length]);

  const nextSlide = () => {
    if (!vids.length) return;
    setCurrentSlide((prev) => (prev + 1) % vids.length);
  };

  const prevSlide = () => {
    if (!vids.length) return;
    setCurrentSlide((prev) => (prev === 0 ? vids.length - 1 : prev - 1));
  };

  const togglePlay = () => {
    const el = videoRef.current;
    if (!el) return;
    if (el.paused) {
      const p = el.play();
      // handle browsers that return a promise
      if (p && typeof p.then === "function") {
        p.then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
      } else {
        setIsPlaying(true);
      }
    } else {
      el.pause();
      setIsPlaying(false);
    }
  };

  return (
    <section className="video-photos">
      <Title text="VIDEO & PHOTOs" />

      <div className="video-photos-container">
        {/* Left side images */}
        <div className="side-images left">
          {(gallery || []).slice(0, 3).map((item) => (
            <div key={item.id} className="side-image-container">
              <img src={item.image} alt="" className="side-image" />
            </div>
          ))}
        </div>

        {/* Main slider */}
        <div className="main-slider">
          {/* Show slider navigation only if videos exist */}
          {vids.length > 0 && (
            <SliderNavigation
              onPrevClick={prevSlide}
              onNextClick={nextSlide}
              canPrev={true}
              canNext={true}
            />
          )}
          <div className="slider-content">
            {vids.length > 0 && (
              <>
                <video
                  key={vids[currentSlide]?.id || currentSlide} // ensure fresh element each slide
                  className="slider-image"
                  ref={videoRef}
                  onEnded={() => setIsPlaying(false)}
                  onPause={() => setIsPlaying(false)}
                  onPlay={() => setIsPlaying(true)}
                  controls={false}
                  playsInline
                // optional: poster={vids[currentSlide]?.image}
                >
                  <source
                    src={vids[currentSlide]?.video}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>

                <div className="slider-info">
                  <div className="slider-date">
                    {vids[currentSlide]?.created_at}
                  </div>
                  <h3 className="slider-title">{vids[currentSlide]?.title}</h3>
                  <p className="slider-subtitle">{vids[currentSlide]?.subtitle}</p>
                </div>

                {/* Custom Play/Pause Button — always visible so you can pause */}
                <div className="image-overlay">
                  <button
                    className="play-button large"
                    onClick={togglePlay}
                    aria-label={isPlaying ? "Pause video" : "Play video"}
                  >
                    {isPlaying ? <FaPause /> : <FaPlay />}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Right side images */}
        <div className="side-images right">
          {(gallery || []).slice(3, 6).map((item) => (
            <div key={item.id} className="side-image-container">
              <img src={item.image} alt="" className="side-image" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoPhotos;
